import type { IconProps } from '@openeducation/oe-it-shared-types';
import React from 'react';
import Svg, { Path, Mask, G } from 'react-native-svg';

export const PracticeIcon = ({ fill }: IconProps) => {
  return (
    <Svg width={42} height={42} viewBox="0 0 42 42" fill="none">
      <Path
        d="M21 41.8145C32.3218 41.8145 41.5 32.6363 41.5 21.3145C41.5 9.99262 32.3218 0.814453 21 0.814453C9.67816 0.814453 0.5 9.99262 0.5 21.3145C0.5 32.6363 9.67816 41.8145 21 41.8145Z"
        fill={fill}
      />
      <Mask
        id="mask0_3345_67924"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="10"
        y="12"
        width="21"
        height="20"
      >
        <Path d="M10.473 12.1484H30.349V31.7724H10.473V12.1484Z" fill="white" />
      </Mask>
      <G mask="url(#mask0_3345_67924)">
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.012 28.6245C16.96 28.6245 13.662 25.3685 13.662 21.3675C13.662 17.3655 16.96 14.1105 21.012 14.1105C25.066 14.1105 28.363 17.3655 28.363 21.3675C28.363 25.3685 25.066 28.6245 21.012 28.6245ZM21.012 12.1485C15.864 12.1485 11.675 16.2835 11.675 21.3675C11.675 26.4505 15.864 30.5855 21.012 30.5855C26.161 30.5855 30.349 26.4505 30.349 21.3675C30.349 16.2835 26.161 12.1485 21.012 12.1485Z"
          fill="white"
        />
      </G>
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.878 21.0825H21.682V16.1005C21.6804 15.8983 21.5987 15.7049 21.4547 15.5628C21.3107 15.4207 21.1163 15.3415 20.914 15.3425C20.7115 15.3412 20.5168 15.4203 20.3727 15.5624C20.2285 15.7045 20.1466 15.8981 20.145 16.1005V21.8405C20.145 22.2605 20.49 22.6005 20.914 22.6005H25.878C26.303 22.6005 26.648 22.2605 26.648 21.8405C26.6472 21.7402 26.6267 21.641 26.5876 21.5486C26.5484 21.4562 26.4915 21.3725 26.42 21.3021C26.3485 21.2317 26.2638 21.1761 26.1708 21.1384C26.0778 21.1007 25.9783 21.0818 25.878 21.0825Z"
        fill="white"
      />
    </Svg>
  );
};

export default PracticeIcon;
